"use strict";

var paymentAPI = require("app/util/api/payment-api");
var _ = require("underscore");
var Intl = require("intl");
var ReactIntl = require("react-intl");

var PlanSelector = require("./plan-selector");
var DEFAULT_PLAN_USERS_NUMBER = 1;
var BASE_PLAN_GROUP = window.loggedUserAccountPlanGroup || "pro";

var PlanSelectorContainer = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getInitialState: function () {
    return {
      currentPlan: null,
      usersNumber: null,
      basePlan: {}
    };
  },
  componentDidMount: function() {
    this.loadBasePlan(this.loadCurrentPlan);
  },
  loadBasePlan: function (loadCurrentPlan) {
    function setBasePlanToState(err, response) {
      if (response && response.body[0]) {
        var basePlan = response.body[0];
        this.setState({
          basePlan: basePlan
        });
        loadCurrentPlan();
      }
    }
    var params = {
      group: BASE_PLAN_GROUP,
      usersLimit: DEFAULT_PLAN_USERS_NUMBER,
      applyDiscount: true,
      cache: false
    };
    paymentAPI.getPlans(setBasePlanToState.bind(this), params);
  },
  loadCurrentPlan: function() {
    function setCurrentPlanToState(err, response) {
      if (response && response.body) {
        this.setState({
          currentPlan: response.body
        });
      }
      this.selectInitialUsers(response.body);
    }
    if(this.props.currentPlanId != undefined) {
      paymentAPI.getPlanByID(setCurrentPlanToState.bind(this), this.props.currentPlanId);
    } else {
      this.onSelect(DEFAULT_PLAN_USERS_NUMBER);
    }
  },
  selectInitialUsers: function(currentPlan) {
    this.setState({
      usersNumber: currentPlan.maxUsers
    });
    },
  onSelect: function (usersNumber) {
    this.setState({
      usersNumber: usersNumber
    });
  },
  render: function() {
    return (
      <PlanSelector {...this.props} {...this.state} onSelect={this.onSelect} />
    );
  }
});

module.exports = PlanSelectorContainer;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-selector-container.jsx